<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">Customer</h2>
      <br />
      <el-button style="float: right; margin-right: 30px" @click="Create()"
        >Create</el-button
      >
    </el-row>
    <br />
    <el-card>
      <el-table
        ref="table"
        v-loading="loading"
        :data="customers"
        class="border"
      >
        <el-table-column prop="_id" label="Domain">
          <template slot-scope="scope">
            <a :href="`https://${scope.row.domain}`">{{ scope.row.domain }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name">
          <template slot-scope="{ row }">
            <template v-if="row.edit">
              <el-input v-model="row.name" class="edit-input" size="small" />
            </template>
            <span v-else>{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="Email">
          <template slot-scope="{ row }">
            <template v-if="row.edit">
              <el-input v-model="row.email" class="edit-input" size="small" />
            </template>
            <span v-else>{{ row.email }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="Address">
          <template slot-scope="{ row }">
            <template v-if="row.edit">
              <el-input
                type="textarea"
                v-model="row.address"
                class="edit-input"
                size="small"
              />
            </template>
            <span v-else>{{ row.address }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="Phone">
          <template slot-scope="{ row }">
            <template v-if="row.edit">
              <el-input
                rows="2"
                v-model="row.phone"
                class="edit-input"
                size="small"
              />
            </template>
            <span v-else>{{ row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="subscriptionDate" label="Subscribetion Date">
          <template slot-scope="{ row }">
            <template v-if="row.edit">
              <el-date-picker
                v-model="row.subscriptionDate"
                type="date"
                align="right"
              ></el-date-picker>
            </template>
            <span v-else>{{ dateFormat(row.subscriptionDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isActive" label="Is isActive">
          <template slot-scope="{ row }">
            <template v-if="row.edit">
              <el-switch
                v-model="row.isBanned"
                inactive-color="#13ce66"
                active-color="#ff4949"
                active-text="Blocked"
                inactive-text="Active"
              >
              </el-switch>
            </template>
            <span v-else>{{
              row.isBanned ?   "Blocked" :"Active"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Actions" width="200">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.edit"
              type="success"
              size="small"
              icon="el-icon-circle-check"
              @click="confirmEdit(row)"
              >Save</el-button
            >
            <el-button
              v-if="row.edit"
              class="cancel-btn"
              size="small"
              icon="el-icon-refresh"
              @click="cancelEdit(row)"
              >cancel</el-button
            >
            <el-button
              v-if="!row.edit"
              type="primary"
              size="small"
              icon="el-icon-edit"
              @click="row.edit = !row.edit"
              >Edit</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog width="30%" title="Customer" :visible.sync="showForm">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        v-loading="formLoading"
        label-width="170px"
      >
        <el-form-item label="Domain" prop="domain">
          <el-input placeholder="Please input" v-model="form.domain">
          </el-input>
        </el-form-item>
        <el-form-item label="Company Name" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="Phone" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="Address" prop="address">
          <el-input type="textarea" :rows="2" v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item label="Subscription Date" prop="subscriptionDate">
          <el-date-picker
            v-model="form.subscriptionDate"
            type="date"
            align="right"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="!this.editId"
            type="primary"
            @click="CreateCustomer()"
            >Create</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
export default {
  name: "Customer",
  data() {
    return {
      formLoading: false,
      showForm: false,
      editId: "",
      showMobileUserLimit: false,
      form: {
        id: "",
        domain: "",
        name: "",
        email: "",
        phone: "",
        address: "",
        subscriptionDate: "",
      },
      rules: {
        domain: [
          {
            required: true,
            message: "Please input domain",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "Please input name", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "Please input phone", trigger: "blur" },
        ],
        email: [
          {
            required: true,
            message: "Please input email",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "Please input address", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getCustomers();
  },
  computed: {
    customers() {
      return this.$store.state.customer.customers.map((customer) => {
        return {
          edit: false,
          original: {
            ...customer,
          },
          ...customer,
        };
      });
    },
    ...mapState("customer", ["loading"]),
  },
  methods: {
    ...mapActions("customer", [
      "getCustomers",
      "createCustomer",
      "updateCustomer",
    ]),
    dateFormat(subscriptionDate) {
      return dayjs(subscriptionDate).format("YYYY-MM-DD");
    },
    cancelEdit(row) {
      row.edit = false;
      row.name = row.original.name;
      row.phone = row.original.phone;
      row.email = row.original.email;
      row.address = row.original.address;
      row.logo = row.original.logo;
      row.isBanned = row.original.isBanned;
    },
    confirmEdit(row) {
      row.edit = false;
      row.original.name = row.name;
      row.original.phone = row.phone;
      row.original.email = row.email;
      row.original.subscriptionDate = dayjs(row.subscriptionDate).format(
        "YYYY-MM-DD"
      );
      row.original.address = row.address;
      row.original.isBanned = row.isBanned;
      this.updateCustomer(row);
    },
    CreateCustomer() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.formLoading = true;
          this.form.domain.toLowerCase();
          this.createCustomer(this.form)
            .then(() => {
              this.formLoading = false;
              this.showForm = false;
            })
            .finally(() => {
              this.formLoading = false;
              this.getCustomers();
            });
        }
      });
    },
    Delete(id) {
      this.$confirm(
        "This will permanently delete the partnerUser. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => this.deleteCustomer(id))
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    Create() {
      this.editId = undefined;
      this.showForm = true;
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.edit {
  opacity: 0;
}

.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>